import { Serializer } from "../resource/serializer.interface";
import { PreferenceDashboard } from "./preferente-dashboard.model";

export class PreferenceDashboardSerializer implements Serializer {
    fromJson(json: any): PreferenceDashboard {
        const dashboard = new PreferenceDashboard();
        dashboard.id = json.id;
        dashboard.name = json.name;
        dashboard.value = json.value
       
        return dashboard;
    }

    toJson(dashboard: PreferenceDashboard): any {
        return {
            id: dashboard.id,
            name: dashboard.name,
            value: dashboard.value
            
        };
    }
}